import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-cycle
import { Section, mmyUrlFromVehicle } from 'components/Comparison';
import { screen } from 'components/styles/variables';
import ListingsCarousel from 'components/ListingsCarousel';
import Comparison, { Vehicle } from 'types/Apis/Comparison';

export const SearchResults = ({
  results,
  vehicle,
}: {
  results?: Record<string, any>;
  vehicle: Vehicle;
}): JSX.Element | null => {
  const { t } = useTranslation();
  if (!results) {
    return null;
  }

  const { year, make, model } = vehicle;

  if (!make || !model) {
    return null;
  }

  return (
    <div className="search-results">
      <h4 className="title">{t('comparison.listings.ymm', { year, make, model })}</h4>
      <a href={mmyUrlFromVehicle({ year, make, model })} className="count-link">
        {t('comparison.listings.viewAll', { count: results.total_count })}
      </a>
      <ListingsCarousel listings={results.records} />
      <style jsx>{`
        .search-results {
          margin-top: 30px;
        }

        .title {
          font-size: 23px;
          line-height: 23px;
          margin: 0 0 0 15px;
        }

        @media (min-width: ${screen.smMin}) {
          .title {
            margin-left: 0;
          }
        }

        .count-link {
          margin: 0 0 0 15px;
        }

        @media (min-width: ${screen.smMin}) {
          .count-link {
            margin-left: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default function AvailableListings({
  comparison,
  listings,
}: {
  comparison: Comparison;
  listings: Record<string, any>;
}): JSX.Element | null {
  const { t } = useTranslation();

  if (!listings.vehicle1 && !listings.vehicle2) {
    return null;
  }

  return (
    <div className="available-listings">
      <Section>
        <h3 className="title">{t('comparison.listings.available')}</h3>
      </Section>
      <Section rowClassName="row--no-gutters-xs">
        <SearchResults vehicle={comparison.vehicle1} results={listings.vehicle1} />
        <SearchResults vehicle={comparison.vehicle2} results={listings.vehicle2} />
      </Section>
      <style jsx>{`
        .available-listings {
          margin-top: 60px;
        }

        .title {
          font-size: 36px;
          line-height: 36px;
          margin: 0;
        }
      `}</style>
    </div>
  );
}
